const fmtDate = (r) => (r.created_at ? String(r.created_at).slice(0, 19).replace("T", " ") : "");
const addon = (tier, qty) => (tier ? `${tier} × ${qty}` : "");

export const CAMP_COLUMNS = [
  { label: "Created", get: fmtDate },
  { label: "Athlete", get: (r) => `${r.athlete_first_name} ${r.athlete_last_name}` },
  { label: "DoB", get: (r) => r.athlete_dob },
  { label: "Sex", get: (r) => r.athlete_sex || "" },
  { label: "Position", get: (r) => r.athlete_position || "" },
  { label: "Club", get: (r) => r.athlete_club || "" },
  { label: "Guardian", get: (r) => r.guardian_name },
  { label: "Email", get: (r) => r.guardian_email },
  { label: "Phone", get: (r) => r.guardian_phone },
  { label: "Country", get: (r) => r.guardian_country || "" },
  { label: "Camp", get: (r) => r.camp_slug },
  { label: "Fee tier", get: (r) => r.camp_fee_tier || "" },
  { label: "Camp fee $", get: (r) => r.camp_fee_usd ?? 0 },
  { label: "Ind. training", get: (r) => addon(r.addon_individual_training_tier, r.addon_individual_training_qty) },
  { label: "GK training", get: (r) => addon(r.addon_gk_training_tier, r.addon_gk_training_qty) },
  { label: "Analyst", get: (r) => addon(r.addon_analyst_tier, r.addon_analyst_qty) },
  { label: "Add-ons $", get: (r) => r.addons_estimate_usd ?? 0 },
  { label: "Total $", get: (r) => r.grand_total_usd ?? 0 },
  { label: "Notes", get: (r) => r.notes || "" },
  { label: "Lang", get: (r) => r.language },
];

export const CONSULT_COLUMNS = [
  { label: "Created", get: fmtDate },
  { label: "Name", get: (r) => r.name },
  { label: "Email", get: (r) => r.email },
  { label: "Phone", get: (r) => r.phone || "" },
  { label: "Country", get: (r) => r.country || "" },
  { label: "Sport", get: (r) => r.sport || "" },
  { label: "Grad. Year", get: (r) => r.graduation_year || "" },
  { label: "Message", get: (r) => r.message || "" },
  { label: "Lang", get: (r) => r.language },
];

export const NEWSLETTER_COLUMNS = [
  { label: "Created", get: fmtDate },
  { label: "Email", get: (r) => r.email },
  { label: "Source", get: (r) => r.source },
  { label: "Lang", get: (r) => r.language },
];

export const COLUMNS_BY_TAB = {
  camps: CAMP_COLUMNS,
  consultations: CONSULT_COLUMNS,
  newsletter: NEWSLETTER_COLUMNS,
};

export const toCSV = (rows, columns) => {
  if (!rows.length) return "";
  const esc = (v) => {
    if (v == null) return "";
    const s = String(v).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const header = columns.map((c) => esc(c.label)).join(",");
  const body = rows.map((r) => columns.map((c) => esc(c.get(r))).join(",")).join("\n");
  return `${header}\n${body}`;
};

export const downloadCSV = (name, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${name}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const filterRows = (rows, q) => {
  const needle = q.trim().toLowerCase();
  if (!needle) return rows;
  return rows.filter((r) => Object.values(r).some((v) => v != null && String(v).toLowerCase().includes(needle)));
};
